/** Where the Booking-system sync page lives (menu, App.js, the Onboarding page's link). */
export const SYNC_PATH = '/import/sync';
